import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from 'src/app/shared/services/search.service';
import { Result } from './search.model';
import { BannerService } from 'src/app/shared/services/banner.service';
import { Banner } from '../home/home.model';

declare var $: any;
@Component({
    selector: 'app-search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit {
    keyword: string;
    devices: Result;

    page: number = 1;
    metadata = {
        limit: 0,
        offset: 0,
        total: 0
    };

    sortDatePrice = 'new';
    type = '';
    brandName: string;
    banners: Banner;

    constructor(
        private route: ActivatedRoute,
        private searchService: SearchService,
        private router: Router,
        private bannerService: BannerService
    ) {
        this.route.params.subscribe(Response => {
            this.keyword = Response.keyword;
            // console.log(this.keyword);
        });

        // reuse route
        this.router.routeReuseStrategy.shouldReuseRoute = function() {
            return false;
        };

        this.bannerService.getBanner('adsLeft').subscribe((res: Banner) => {
            this.banners = res;
        });
    }

    ngOnInit() {
        this.result();
        this.adleft();

        const search = document.getElementById('search');
        const button = document.getElementById('button');
        const input = document.getElementById('input');

        function loading() {
            search.classList.add('loading');

            setTimeout(function() {
                search.classList.remove('loading');
            }, 1500);
        }

        button.addEventListener('click', loading);

        input.addEventListener('keydown', function(event) {
            if (event.keyCode === 13) {
                loading();
            }
        });
    }

    result() {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        const offset = (this.page - 1) * 5;

        this.searchService
            .searchProduct(offset, this.keyword, this.brandName, this.type, this.sortDatePrice)
            .subscribe((res: Result) => {
                this.metadata = (res as any).metadata;
                this.devices = res;
            });
    }

    adleft() {
        this.bannerService.getBanner('adsLeft').subscribe((res: Banner) => {
            this.banners = res;
        });
    }
}
